// extracted by mini-css-extract-plugin
module.exports = {"bankDetails":"BankDetails_bankDetails__1aCDy","form":"BankDetails_form__2M0v5","info":"BankDetails_info__1HRof","input":"BankDetails_input__8uPjL"};